import styled from "styled-components";
import { pxToRem } from "../../styles/utils";


export const ChartContainer = styled.div`
  width: 100%;
  height: 100%;
`;

export const ControlsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${pxToRem(16)};
  margin-bottom: ${pxToRem(16)};
  align-items: center;
  padding: ${pxToRem(19)} ${pxToRem(16)};
`;

export const ControlLabel = styled.label`
  display: flex;
  flex-direction: column;
  font-size: ${pxToRem(14)};
  color: rgb(31, 10, 53);
  gap: ${pxToRem(8)};

  .p-inputtext {
    width: ${pxToRem(200)};
  }

  input[type="text" i] {
    color: rgb(114, 82, 220);
    font-size: ${pxToRem(12)};
    font-weight: 400;
    text-align: center;
  }
`;

export const DateInput = styled.input`
  padding: ${pxToRem(8)};
  border: ${pxToRem(1)} solid rgba(0, 0, 0, 0.1);
  border-radius: ${pxToRem(8)};
  font-size: ${pxToRem(14)};
`;

export const Select = styled.select`
  padding: ${pxToRem(8)};
  border: ${pxToRem(1)} solid rgba(0, 0, 0, 0.1);
  border-radius: ${pxToRem(8)};
  font-size: ${pxToRem(14)};
`;

export const ModeSwitchContainer = styled.div`
  display: flex;
  gap: ${pxToRem(8)};
  margin-bottom: ${pxToRem(16)};
`;

export const ModeButton = styled.button<{ isActive: boolean }>`
  height: ${pxToRem(40)};
  padding: ${pxToRem(8)} ${pxToRem(16)};
  border-radius: ${pxToRem(8)};
  border: none;
  cursor: pointer;
  background-color: ${({ isActive }) => (isActive ? "rgba(114, 82, 220, 1)" : "#e0e0e0")};
  color: ${({ isActive }) => (isActive ? "white" : "#333")};
  font-size: ${pxToRem(14)};
  font-weight: 600;
  transition: background-color 0.3s, color 0.3s;

  &:hover {
    background-color: ${({ isActive }) => (isActive ? "#5a3bba" : "#d0d0d0")};
  }
`;
